module.exports = __webpack_public_path__ + "static/fx_16.82a0f56f.jpg";